var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.226,
    height: 23.49,
    viewBox: "0 0 25.226 23.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-icon-silhouette",
    transform: "translate(0 -84.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17285",
    "data-name": "Groupe 17285",
    transform: "translate(0.001 84.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17284",
    "data-name": "Groupe 17284",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12121",
    "data-name": "Trac\\xE9 12121",
    d: "M24.8,27.662,20.98,23.839V19.422a1.446,1.446,0,0,0-2.892,0v1.525L15.241,18.1a3.8,3.8,0,0,0-5.258,0L.424,27.662a1.446,1.446,0,1,0,2.046,2.045l9.558-9.559a.854.854,0,0,1,1.17,0l9.56,9.56A1.446,1.446,0,1,0,24.8,27.662Z",
    transform: "translate(-0.001 -17.047)",
    fill: "#ec6321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12122",
    "data-name": "Trac\\xE9 12122",
    d: "M78.247,127.956a.71.71,0,0,0-1,0l-8.408,8.406a.712.712,0,0,0-.208.5V143a2.605,2.605,0,0,0,2.605,2.605h4.163v-6.447h4.7V145.6h4.163a2.605,2.605,0,0,0,2.605-2.6v-6.131a.709.709,0,0,0-.208-.5Z",
    transform: "translate(-65.133 -122.111)",
    fill: "#ec6321"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.98ceac2d09a6e1c60b22f9d34d537306.svg";
export { ForwardRef as ReactComponent };